import { render, staticRenderFns } from "./NisScoreTimeline.vue?vue&type=template&id=537a32c3"
import script from "./NisScoreTimeline.vue?vue&type=script&lang=js"
export * from "./NisScoreTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports